import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getTests } from '../../api';

export default function TestHistory() {
  const navigate = useNavigate();
  const { data: tests = [], isLoading } = useQuery({ queryKey: ['tests'], queryFn: () => getTests().then(r => r.data) });

  return (
    <div>
      <h1 style={{ fontSize: 26, marginBottom: 8 }}>My Tests</h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 28 }}>{tests.length} tests total</p>
      {isLoading ? <div className="spinner" /> : (
        <div className="card" style={{ padding: 0 }}>
          <table className="table">
            <thead><tr><th>Test</th><th>Questions</th><th>Status</th><th>Date</th><th></th></tr></thead>
            <tbody>
              {tests.length === 0 ? <tr><td colSpan={5} className="empty-state" style={{padding:40}}>No tests yet.</td></tr>
                : tests.map(t => (
                <tr key={t.id}>
                  <td style={{ fontWeight: 500 }}>{t.title || 'Untitled Test'}</td>
                  <td>{t.total_questions}</td>
                  <td><span className={`badge ${t.status === 'completed' ? 'badge-green' : 'badge-yellow'}`}>{t.status}</span></td>
                  <td style={{ color: 'var(--text-muted)', fontSize: 13 }}>{new Date(t.started_at).toLocaleDateString()}</td>
                  <td>
                    {t.status === 'completed'
                      ? <button className="btn btn-ghost btn-sm" onClick={() => navigate(`/student/test/${t.id}/result`)}>View Result</button>
                      : <button className="btn btn-primary btn-sm" onClick={() => navigate(`/student/test/${t.id}`)}>Resume</button>
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
